import React from 'react';
import { CheckableButton } from "components/CheckableButton/CheckableButton";

interface PositionSettingsProps {
    object: any;
}

export const PositionSettings: React.FC<PositionSettingsProps> = ({ object }) => {
    return (
        <div className="col-12">
            <div className="d-flex align-items-end w-100 h-100">
                <CheckableButton
                    type="checkbox"
                    labelText="hidden"
                    inputName="hidden"
                    defaultChecked={object?.hidden || false}
                    defaultValue={object?.hidden || false}
                />
            </div>
        </div>
    );
}; 